import React from "react";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/20/solid";
import toast, { Toast } from "react-hot-toast";

interface NotificationProps {
  t?: Toast; // Provided automatically by toast.custom
  isSuccess?: boolean;
  message: string;
  info?: string;
}

const Notification: React.FC<NotificationProps> = ({
  t,
  isSuccess = false,
  message,
  info,
}) => (
  <div className="pointer-events-auto w-auto max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 p-4">
    <div className="flex items-center">
      {isSuccess ? (
        <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true" />
      ) : (
        <ExclamationCircleIcon className="h-6 w-6 text-red-400" aria-hidden="true" />
      )}
      <div className="ml-3 flex-1">
        <p className="text-sm font-medium text-gray-900">{message}</p>
        {info && <p className="mt-1 text-sm text-gray-500">{info}</p>}
      </div>
      <button
        type="button"
        className="ml-4 inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
        onClick={() => t && toast.dismiss(t.id)}
      >
        <span className="sr-only">Close</span>
        <XMarkIcon className="h-5 w-5" aria-hidden="true" />
      </button>
    </div>
  </div>
);

export default Notification;
